// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SelectAll_root__2V-_k {\n  color: var(--accent-base);\n  font-size: 12px;\n  -webkit-user-select: none;\n          user-select: none;\n  margin-bottom: 0.5rem;\n  cursor: pointer;\n}\n", "",{"version":3,"sources":["webpack://node_modules/@energybox/react-ui-library/dist/components/SelectAll/SelectAll.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":[".root {\n  color: var(--accent-base);\n  font-size: 12px;\n  user-select: none;\n  margin-bottom: 0.5rem;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "SelectAll_root__2V-_k"
};
export default ___CSS_LOADER_EXPORT___;
